// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Go-z","slideIn":"Ho-z"};